import React from 'react'

import { useSelector } from 'react-redux'

import HoverableInformation from '@components/UI/Information/HoverableInformation/HoverableInformation'
import ConnectedTrackedRoute from '@components/UI/TrackedRoute/ConnectedTrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectPaymentMethod } from '@store/campaigns'
import CampaignBudgetTipContent, { CAMPAIGN_BUDGET_TIP_CONTENT_TIP_ID } from './TipContent'

interface IProps {
  campaignId: number
}

const CampaignBudgetHoverableIcon: React.FC<IProps> = ({ campaignId }) => {
  const paymentMethod = useSelector((state: IApplicationState) =>
    selectPaymentMethod(state, campaignId),
  )

  return (
    <ConnectedTrackedRoute
      eventTrigger="mouseEnter"
      eventName={EventTrackingNames.BudgetPanelHover}
      campaignId={campaignId}
      additionalProperties={{
        budget_type: paymentMethod,
      }}
    >
      <HoverableInformation
        width={24}
        xPosition="right"
        glyph="information"
        iconSize={1}
        waypointYOffset={270}
        topOffset={12}
        testId="campaign-budget-hoverable-icon"
      >
        <CampaignBudgetTipContent
          campaignId={campaignId}
          paymentMethod={paymentMethod}
          key={CAMPAIGN_BUDGET_TIP_CONTENT_TIP_ID}
        />
      </HoverableInformation>
    </ConnectedTrackedRoute>
  )
}

export default CampaignBudgetHoverableIcon
